module.exports = __webpack_public_path__ + "img/team-6.b663e6ce.jpg";